<template>
  <v-container>
    <!-- Заголовок -->
    <v-row justify="center">
      <v-col cols="12" class="text-center">
        <h1 class="text-h4 mt-6 mb-6">Действующие проекты</h1>
      </v-col>
    </v-row>

    <!-- Карточки -->
    <v-row>
      <v-col
          v-for="item in projects"
          :key="item.id"
          cols="12"
          sm="6"
          md="4"
          class="d-flex"
      >
        <NewsListForInsert :item="item" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { news } from '@/data/news'
import NewsItem from "@/pages/NewsItem.vue";

export default {
  components: {NewsListForInsert: NewsItem},
  computed: {
    projects() {
      return news.filter(item => item.category === 'Проект')
    }
  }
}
</script>

<style scoped lang="sass">
.news-card
  display: flex
  flex-direction: column
  height: 100%

.v-card-text
  flex-grow: 1
  display: flex
  flex-direction: column

.v-btn
  margin-top: auto

.desc
  display: -webkit-box
  -webkit-line-clamp: 3
  -webkit-box-orient: vertical
  overflow: hidden
</style>